import type { HealthBehaviour } from "@healthos/shared";
import { BowlFood, Heart, type Icon, Moon, PersonSimpleWalk, Wind } from "@phosphor-icons/react";

export interface MicrostepBehaviourVisual {
  color: string;
  Icon: Icon;
}

export const MICROSTEP_BEHAVIOUR_VISUALS = {
  sleep: { color: "var(--color-behaviour-sleep)", Icon: Moon },
  food: { color: "var(--color-behaviour-food)", Icon: BowlFood },
  movement: { color: "var(--color-behaviour-movement)", Icon: PersonSimpleWalk },
  stress: { color: "var(--color-behaviour-stress)", Icon: Wind },
  connection: { color: "var(--color-behaviour-connection)", Icon: Heart },
} satisfies Record<HealthBehaviour, MicrostepBehaviourVisual>;
